<template>
  <el-form-item :label="form.name" :prop="form.model"
               :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
               style="padding-left:10px;line-height:36px;"
  >
    <el-input-number v-model.number="value[form.model]"
              :placeholder="form.options.placeholder"
              :disabled="inputDisable"
              @input="onInput"
               @focus="focus($event)"
              class="textAlign"
              style="width:226px;text-align: right;"
              :type="form.options.dataType"
              controls-position="right"
              @change="numChange"
              :min="form.options.min"
              :max="form.options.max"
              :step="form.options.step"
              :precision="getPrecision(form.options.step)"
    >
    </el-input-number>
  </el-form-item>
</template>

<script>
export default {
  name: 'DynamicInputNumber',
  data () {
    return {
      key: '',
      formData: {},
      mainValue: ''
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: "",
            required: false,
            defaultValue: 0,
            min: 0,
            max: 0,
            step: 1,
            precision:0,
            disabled: false,
            controlsPosition: "",
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val
      }
    }
  },
  methods: {
     focus(event) {
        event.currentTarget.select();
    },
    onInput () {
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    numChange(val){
      let that = this
      if(!val){
        that.value[that.form.model]=0;
      }
    },
    getPrecision(val){
      if(val){
        var bb=val.toString().replace(/\d+\.(\d*)/,"$1");
        if(val.toString().indexOf(".")>0){
          return bb.length
        }else{
          return 0
        }
      }else{
        return 2
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>
  .el-input-number{
    width:229.49px;
  }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicInputNumber.vue"
}
</vue-filename-injector>
